import { useEffect, useState } from "react";

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label="返回页面顶部"
      className={`fixed bottom-6 right-5 z-40 flex h-11 w-11 items-center justify-center rounded-md border border-background-200 bg-background-50 text-foreground-800 transition-all duration-300 hover:border-primary-400 hover:text-primary-600 ${
        visible ? "opacity-100 translate-y-0" : "pointer-events-none opacity-0 translate-y-3"
      }`}
    >
      <i className="ri-arrow-up-line text-lg" aria-hidden="true"></i>
    </button>
  );
}